// IntersectionObserverAPIを使用してビューポート内での表示を検知、クラス付与
const doObserve = (element) => {
  const targets = document.querySelectorAll(element);
  const options = {
    root: null,
    rootMargin: '-100px 0px', // ネガティブな値を指定して、要素が100px進入するのを待つ
    threshold: 0
  };
  const observer = new IntersectionObserver((items) => {
    items.forEach((item) => {
      if (item.isIntersecting) {
        item.target.classList.add('-observed');
      } else {
        item.target.classList.remove('-observed');
      }
    });
  }, options);
  Array.from(targets).forEach((target) => {
    observer.observe(target);
  });
};
doObserve('.js-observe-target');


//スクロールしてsp用の診断エリアが見えなくなったらpc用の診断エリアを表示
$(function() {
  const pcChartBtn = $('.l-navigation__chartButton');
  const scrollContainer = $('#scrollContainer'); // scrollContainerの要素を取得
  //scrollしたとき
  $(scrollContainer).on('scroll', function () {
    // 現在の位置が500pxより大きい時
    if ($(scrollContainer).scrollTop() > 500 ) {
      // クラスを付与
      pcChartBtn.addClass('is-active');
    }
    // 現在の位置が500px以下かつ、クラスfixedが付与されている時にfixedを外す
    else if ($(scrollContainer).scrollTop() <= 500) {
      pcChartBtn.removeClass('is-active');
    }
  });
});
